// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"horizontal-scroll_scrollWrapper__KKaH6","scroll":"horizontal-scroll_scroll__+x02o"};